package com.esoris.kmpmoout.domaindata.expense


data class Expense(
    val id: String,
    val userId: String,
    val amount: Long,
    val category: String,
    val note: String?,
    val createdAt: Long?
)